<div>
  <app-classifiers-filters (search)="search($event)"></app-classifiers-filters>
  <mat-divider></mat-divider>
  <app-classifiers-table *ngIf="classifiersPage"
                         [list]="classifiersPage.content"
                         [pageSize]="classifiersPage.size"
                         [totalElements]="classifiersPage.totalElements"
                         [origin]="origin"
                         [originStep]="originStep"
                         (loadItems)="loadClassifiers($event)"
                         (createItem)="create($event)"
                         (updateItem)="update($event)"
                         (deleteItem)="delete($event)">
  </app-classifiers-table>
</div>
